import { createUseStyles } from 'react-jss'
import { BLUE, BRIGHT_GRAY, DARK_GRAY_60, LIGHT_GRAY, WHITE } from '@omnilert/components'

const useStyles = createUseStyles({
  buttons: {
    padding: '30px 0'
  },
  container: {
    backgroundColor: WHITE,
    height: '100%',
    overflowY: 'auto',
    padding: '24px',
    width: '100%'
  },
  customTextarea: {
    display: 'inline',
    fontSize: '16px',
    overflowY: 'auto',
    marginBottom: 10,
    padding: '14px',
    paddingRight: '60px',
    '&::placeholder': {
      color: LIGHT_GRAY,
      fontFamily: 'BentonSansBold'
    }
  },
  field: {
    marginBottom: '0.75rem'
  },
  fieldContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    width: '100%'
  },
  iconTextContainer: {
    alignItems: 'flex-end',
    color: DARK_GRAY_60,
    display: 'flex',
    fontFamily: 'BentonSansBold'
  },
  pin: {
    marginRight: '15px'
  },
  responsive: {
    flexDirection: 'column',
    margin: '0 auto',
    paddingBottom: '15px'
  },
  outline: {
    borderColor: BLUE,
    color: BLUE
  },
  switch: {
    alignItems: 'center',
    backgroundColor: WHITE,
    borderBottom: `1px solid ${BRIGHT_GRAY}`,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0',
    padding: '22px 0'
  }
})

export default useStyles
